export const initialState = () => ({
  nodes: [],
  selectedPatient: {
    text: '',
    patientId: null,
  },
  isResetRequired: false,
});

export default initialState();
